import * as React from "react";
import { Typography, Button } from "antd";
import { IOrganisationIndexCategory } from "../../../organisations/model/OrganisationIndexCategory";
import SelectInput from "../../../core/ui/components/SelectInput";
import { IUser } from "../../../user/model/User";
export interface State {}
export interface Props {
  translate: any;
  organisationIndexCategories: IOrganisationIndexCategory[];
  setOrganisationIds: (organisationIds: number[]) => void;
  setCategoryId: (categoryId: number) => void;
  getData: () => void;
  selectedCategoryId: number;
  user?: IUser;
}

export default class IndexHarmonizationReportParamBox extends React.Component<
  Props,
  State
> {
  constructor(props: any) {
    super(props);
    this.state = { ...props, selectedApplicants: [] };
  }

  render() {
    const {
      translate,
      getData,
      selectedCategoryId,
      organisationIndexCategories,
      setCategoryId,
    } = this.props;
    return (
      <div
        style={{
          width: "22%",
          display: "flex",
          flexDirection: "column",
          minWidth: "22%",
          paddingRight: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: 10,
            height: "auto",
          }}
        >
          <Typography.Title style={{ fontSize: 14 }}>
            {translate("reports.category")}
          </Typography.Title>
          <SelectInput
            placeholder={translate("reports.select_categories")}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
            selectOptionKey={"indexTypeCategoryId"}
            selectOptionValue={"name"}
            selectOptions={organisationIndexCategories}
            value={selectedCategoryId}
            onChange={(value) => setCategoryId(value)}
          />
        </div>
        <Button
          disabled={!selectedCategoryId}
          style={{ marginTop: "20px" }}
          type="primary"
          onClick={() => getData()}
        >
          {translate("reports.generate_report")}
        </Button>
      </div>
    );
  }
}
